/** Debe coincidir con config/quotes_permissions.php */
export const QUOTES_ACTION_ALIASES = {
    create: ['add'],
    import: ['add'],
};

export const QUOTES_PERMISSION_ALIASES = {
    'quotes.policies.view': ['quotes.insurance.policy.view', 'quotes.insurance'],
    'quotes.policies.create': ['quotes.insurance.policy.add'],
    'quotes.policies.update_policy': ['quotes.insurance.policy.edit', 'quotes.insurance.policy.admin'],
    'quotes.policies.update_master': ['quotes.insurance.masters.edit'],
    'quotes.policies.show_real_balance': ['quotes.insurance.policy.show_real_balance'],
    'quotes.applications.view': ['quotes.applications.policy.view_any', 'quotes.applications.policy.view'],
    'quotes.applications.create': ['quotes.applications.policy.add'],
    'quotes.applications.edit': ['quotes.applications.policy.edit'],
    'quotes.applications.import_excel': ['quotes.applications.policy.massive_create_excel'],
    'quotes.applications.import_txt': ['quotes.applications.policy.massive_create_txt'],
    'quotes.applications.create_oii': ['quotes.applications.policy.create_oii_file'],
    'quotes.applications.upload_oii': ['quotes.applications.policy.upload_oii_file'],
    'quotes.scheduled_appointments.view': ['quotes.appointments'],
    'quotes.policy_appointments.view': ['quotes.insurance.appointment.history'],
    'quotes.policy_appointments.create': ['quotes.insurance.appointment.add'],
    'quotes.policy_appointments.edit': ['quotes.insurance.appointment.edit'],
    'quotes.policy_payments.view': ['quotes.insurance.payments.history'],
    'quotes.policy_payments.upload': ['actions.upload.payments'],
    'quotes.policy_payments.upload_paid_up': ['actions.upload.paid_up'],
    'quotes.policy_withdrawals.view': ['quotes.insurance.withdrawals.history.view'],
    'quotes.policy_withdrawals.edit': ['quotes.insurance.withdrawals.history'],
    'quotes.financial_projection.import': ['quotes.insurance.financial_proyection'],
    'quotes.biweekly_discounts.view': ['quotes.insurance.biweekly_discount.view'],
    'quotes.biweekly_discounts.create': ['quotes.insurance.biweekly_discount.add'],
    'quotes.biweekly_discounts.edit': ['quotes.insurance.biweekly_discount.edit'],
    'quotes.withdrawals.import': ['quotes.withdrawals.add'],
    'quotes.commissions.create': ['quotes.commissions.add'],
    'quotes.commissions_inbursa.view': ['quotes.commissions.inbursa.view'],
    'quotes.commissions_inbursa.create': ['quotes.commissions.inbursa.add'],
    'quotes.commissions_inbursa.edit': ['quotes.commissions.inbursa.edit'],
    'quotes.commissions_inbursa.delete': ['quotes.commissions.inbursa.delete'],
    'quotes.commission_payments.view': ['quotes.commission_metrics.view'],
    'quotes.commission_payments.create': ['quotes.commission_metrics.add'],
    'quotes.commission_payments.edit': ['quotes.commission_metrics.edit'],
    'quotes.commission_payments.delete': ['quotes.commission_metrics.delete'],
    'quotes.investment_fund.view': ['quotes.insurance.investment_fund.history'],
};

export function quotesCrossAliases(permission) {
    const aliases = [];

    for (const [canonical, legacyNames] of Object.entries(QUOTES_PERMISSION_ALIASES)) {
        if (permission === canonical) {
            aliases.push(...legacyNames);
        }
        if (legacyNames.includes(permission)) {
            aliases.push(canonical);
        }
    }

    return [...new Set(aliases.filter((name) => name !== permission))];
}

export function quotesActionAliases(permission) {
    if (!permission.startsWith('quotes.')) {
        return [];
    }

    const rest = permission.slice('quotes.'.length);
    const dot = rest.indexOf('.');

    if (dot === -1) {
        return [];
    }

    const module = rest.slice(0, dot);
    const action = rest.slice(dot + 1);
    const names = [];

    for (const [canonical, legacyActions] of Object.entries(QUOTES_ACTION_ALIASES)) {
        if (legacyActions.includes(action)) {
            names.push(`quotes.${module}.${canonical}`);
        }
        if (action === canonical) {
            legacyActions.forEach((legacy) => {
                names.push(`quotes.${module}.${legacy}`);
            });
        }
    }

    return names.filter((name) => name !== permission);
}

export function quotesPermissionAliases(permission) {
    return [...quotesCrossAliases(permission), ...quotesActionAliases(permission)];
}
